jQuery(document).ready(function ($) {
    $('.wp-block-wbdm-cards-carousel').each(function () {
        var $block = $(this);
        var $carousel = $block.find('.cards-carousel-cards-container.swiper');
        var $next = $block.find('.swiper-button-next');
        var $prev = $block.find('.swiper-button-prev');
        var $pagination = $block.find('.swiper-pagination');

        new Swiper($carousel[0], {
            slidesPerView: 3.2,
            spaceBetween: 24,
            loop: false,
            navigation: {
                nextEl: $next[0],
                prevEl: $prev[0],
            },
            pagination: {
                el: $pagination[0],
                type: 'progressbar',
            },
            breakpoints: {
                900: {
                    slidesPerView: 3.1,
                },
                600: {
                    slidesPerView: 1,
                },
                0: {
                    slidesPerView: 1,
                }
            }
        });
    });
});
